import TitleTemplate from "../../components/ui/common/template/TitleTemplate";
import PageTemplate from "../../components/ui/common/template/PageTemplate";
import WorkScopes from "../../components/ui/specialty/WorkScopes";
import DevImage from "../../resources/images/dev.jpg";
import ContactPoints from "../../components/ui/members/ContactPoints";
import HeadedBox from "../../components/ui/common/template/HeadedBox";
import CenterDiv from "../../style/styled-components/components/CenterDiv";
import { Link } from "react-router-dom";
import DiamondScope from "../../components/ui/specialty/DiamondScope";
import icClear from "../../resources/images/icon/14. IT/1. 통관 정보제공.png";
import icPortal from "../../resources/images/icon/14. IT/6. 화물 정보 관리.png";
import icHS from "../../resources/images/icon/10. 기업진단/2. 품목분류 적정성  일관성 진단.png";
import icAudit from "../../resources/images/icon/10. 기업진단/1. 관세업무 현황진단.png";
import icGSCM from "../../resources/images/icon/7. FTA/4. 원산지요건 확인.png";
import icACES from "../../resources/images/icon/14. IT/8. 특송통관 시스템.png";
import icATLAS from "../../resources/images/icon/7. FTA/8. 각 협정별 법률 자문_rev.png";
import icQuarantine from "../../resources/images/icon/5. 검역/1. 수입식품 컨설팅.png";
import icSales from "../../resources/images/icon/8. AEO/3. AEO 정기자체평가 관리.png";

const DevPage = () => {
  return (
    // 20220713 비전 2033 내용 반영할 것
    <PageTemplate
      large
      image={DevImage}
      title="IT 시스템 연혁"
      aone
      phrase="관세업계 미래를 이끌어 갈 IT First-mover"
    >
      <p>
        에이원은 TCMS를 시작으로 RMS, IVIS 등 다양한 콘텐츠와 플랫폼을 개발하여
        적법성, 업무 효율성 및 고객과의 연결성을 강화해오고 있습니다. 일찍부터
        자체 기술로 OCR 및 PDF 텍스트 변환을 업무에 적용해왔으며, 2024년 국내 최초로
        지능형 HS 품목분류 추천시스템을 개발했습니다. 지금은 모든 시스템을 하나로 잇는
        ASCP 플랫폼으로 고객 여러분과 함께하고 있습니다.
        <br />
        <Link to="/it/ascp">ASCP 플랫폼 보기 →</Link>
      </p>

      <TitleTemplate
        title="IT 진화"
        noImage
        subHeader="통관 자동화에서 출발해 관세무역 플랫폼으로 발전해 왔습니다."
      />
      <CenterDiv>
        <div style={{ display: "flex", flexDirection: "column", gap: "0.8rem" }}>
          <HeadedBox div="TCMS" subdiv="출발" text="자체 개발 통관관리시스템으로 품목마스터·단가·원산지 이력을 관리" />
          <HeadedBox div="RMS · IVIS" subdiv="확장" text="리스크 관리와 정보 서비스로 업무 영역 확대" />
          <HeadedBox div="2024" subdiv="전환" text="스마트 통관 시스템 통합 추진, SaaS 개발육성 정부지원사업 참여, 국내 최초 지능형 HS 품목분류 추천시스템 개발·특허 출원" />
          <HeadedBox div="2025" subdiv="고도화" text="SaaS 기반 통관시스템 개발 및 고도화 추진" />
          <HeadedBox div="ASCP" subdiv="현재" text="TCMS·ACRIS·ATLAS·AXIS·CRM 5개 시스템과 공용 AI 엔진을 하나로 잇는 플랫폼" />
        </div>
      </CenterDiv>
      <TitleTemplate
        title="업무 범위"
        noImage
        subHeader="현재 ASCP 플랫폼에서 운영·개발 중인 시스템과 모듈입니다."
      />
      <WorkScopes
        contents={[
          { title: "TCMS 수입·수출신고 자동화", icon: icClear },
          { title: "ACIP 고객포털 (신고·컨설팅·품목관리)", icon: icPortal },
          { title: "ACRIS AI HS 품목분류", icon: icHS },
          { title: "ACRIS 심사 리스크 진단", icon: icAudit },
          { title: "ACRIS 검역 리스크 진단", icon: icQuarantine },
          { title: "ACRIS GSCM 공급망·수출통제", icon: icGSCM },
          { title: "ACRIS ACES 전자상거래 스크리닝", icon: icACES },
          { title: "ATLAS 통합검색·법률 자문·리서치", icon: icATLAS },
          { title: "AXIS·CRM 견적·보고·AEO·고객 관리", icon: icSales },
        ]}
      />
      <TitleTemplate
        title="Strength"
        noImage
        subHeader="관세 실무 전문가가 직접 설계하고, 결과를 검증합니다."
      />
      <DiamondScope
        contents={[
          {
            title: "Domain Expertise",
            text: "관세사·전직 세관 분류전문가가 판단 기준을 설계하고 검수",
          },
          {
            title: "AI Engines",
            text: "AI HS 분류·실시간 법적근거·RAG 검색·결정적 룰 엔진 자체 개발",
          },
          {
            title: "Verifiable",
            text: "모든 AI 결과에 법령·해설서·판례 근거를 인용",
          },
          {
            title: "Secure Delivery",
            text: "SaaS와 고객사 서버 설치형 중 데이터 성격에 맞게 선택",
          },
        ]}
      />
      <TitleTemplate
        title="Contact Point"
        noImage
        subHeader="언제나 믿고 맡길 수 있는 최고의 멤버와 함께합니다."
      />
      <ContactPoints members={["cupark"]} />
    </PageTemplate>
  );
};
export default DevPage;
